import { makeStyles } from '@material-ui/core'

const useColumnBuilderStyles = makeStyles(() => ({
  dialogLayout: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0
  },
  body: {
    display: 'flex',
    gap: 16,
    maxHeight: 'calc(100vh - 300px)',
    minHeight: 200,
    overflow: 'hidden'
  },
  catalogPanel: {
    flex: '0 0 230px',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid var(--opal-border-default, #e0e0e0)',
    paddingRight: 16,
    overflowY: 'auto',
    minHeight: 0
  },
  columnPanel: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0
  },
  detailPanel: {
    flex: '0 0 380px',
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid var(--opal-border-default, #e0e0e0)',
    paddingLeft: 16,
    overflowY: 'auto',
    minHeight: 0
  },
  panelHeader: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: 'var(--color-neutral-600, #666)',
    marginBottom: 8
  },
  categoryHeader: {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    color: 'var(--color-neutral-500, #888)',
    marginTop: 12,
    marginBottom: 4,
    '&:first-child': { marginTop: 0 }
  },
  catalogItem: {
    fontSize: 13,
    padding: '4px 8px',
    borderRadius: 'var(--border-radius-sm, 4px)',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      background: 'var(--color-primary-50, rgba(25, 118, 210, 0.08))',
      color: 'var(--color-primary-700, #1565c0)'
    }
  },
  columnList: {
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    border: '1px solid var(--opal-border-default, #e0e0e0)',
    borderRadius: 'var(--border-radius-sm, 4px)',
    padding: 4,
    minHeight: 100
  },
  columnRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '7px 8px',
    borderRadius: 'var(--border-radius-sm, 4px)',
    border: '1px solid var(--opal-border-default, #e0e0e0)',
    background: 'var(--theme-color-surface-d0, #fff)',
    fontSize: 13,
    cursor: 'grab',
    userSelect: 'none',
    '&:hover': {
      background: 'var(--color-neutral-100, #f0f0f0)'
    }
  },
  columnRowSelected: {
    background: 'var(--color-primary-50, rgba(25, 118, 210, 0.08))',
    outline: '1px solid var(--color-primary-200, #90caf9)',
    '&:hover': {
      background: 'var(--color-primary-50, rgba(25, 118, 210, 0.08))'
    }
  },
  columnRowDragging: {
    opacity: 0.4
  },
  dragHandle: {
    color: 'var(--color-neutral-400, #aaa)',
    flexShrink: 0
  },
  columnLabelGroup: {
    flex: 1,
    overflow: 'hidden',
    minWidth: 0
  },
  columnLabel: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 500
  },
  columnTypeHint: {
    display: 'block',
    fontSize: 11,
    color: 'var(--color-neutral-500, #888)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: 1.3
  },
  columnDateHint: {
    fontSize: 11,
    color: 'var(--color-neutral-500, #888)',
    flexShrink: 0
  },
  removeBtn: {
    cursor: 'pointer',
    color: 'var(--color-neutral-400, #aaa)',
    flexShrink: 0,
    '&:hover': {
      color: 'var(--color-danger-500, #d32f2f)'
    }
  },
  emptyHint: {
    color: 'var(--color-neutral-400, #aaa)',
    fontSize: 12,
    fontStyle: 'italic',
    padding: 8,
    textAlign: 'center'
  },
  detailTitle: {
    fontSize: 15,
    fontWeight: 600,
    marginBottom: 2,
    color: 'var(--color-neutral-800, #333)'
  },
  detailTypeHint: {
    fontSize: 12,
    color: 'var(--color-neutral-500, #888)',
    marginBottom: 16
  },
  detailSection: {
    marginBottom: 16
  },
  detailSectionLabel: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: 'var(--color-neutral-500, #888)',
    marginBottom: 6
  },
  detailField: {
    marginBottom: 12
  },
  detailFieldLabel: {
    fontSize: 12,
    color: 'var(--color-neutral-600, #666)',
    marginBottom: 4
  },
  dateRangeRow: {
    display: 'flex',
    gap: 8
  },
  dateInput: {
    flex: 1,
    padding: '6px 8px',
    fontSize: 13,
    border: 'var(--border-neutral-thin, 1px solid #ddd)',
    borderRadius: 'var(--border-radius-sm, 4px)',
    background: 'var(--theme-color-surface-d0, #fff)',
    color: 'inherit',
    outline: 'none',
    '&:focus': {
      outline: '1px solid var(--color-primary-500, #1976d2)'
    }
  },
  settingCheckLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 13,
    cursor: 'pointer',
    marginBottom: 4,
    '& input': { margin: 0 }
  },
  multiselectList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxHeight: 220,
    overflowY: 'auto',
    padding: 6,
    border: 'var(--border-neutral-thin, 1px solid #ddd)',
    borderRadius: 'var(--border-radius-sm, 4px)',
    background: 'var(--theme-color-surface-d0, #fff)'
  },
  multiselectWarning: {
    fontSize: 11,
    fontStyle: 'italic',
    color: 'var(--color-danger-600, #c62828)',
    marginTop: 4
  },
  nameInput: {
    width: '100%',
    padding: '6px 8px',
    fontSize: 13,
    border: 'var(--border-neutral-thin, 1px solid #ddd)',
    borderRadius: 'var(--border-radius-sm, 4px)',
    background: 'var(--theme-color-surface-d0, #fff)',
    color: 'inherit',
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
      outline: '1px solid var(--color-primary-500, #1976d2)'
    },
    '&::placeholder': {
      color: 'var(--color-neutral-400, #aaa)',
      fontStyle: 'italic'
    }
  }
}))

export default useColumnBuilderStyles
